/*
 * Filename: cq-template-header.tsx
 */

import React from 'react';
import { observer } from 'mobx-react';

const CQTemplateHeader = (props: { fetchDeployedTemplates: () => void }) => {
    return (
        <div className="slds-grid slds-grid_align-spread bg-white slds-p-around_medium slds-m-bottom_small full-width">
            <div className="slds-media slds-media_center">
                <div className="slds-meida__figure">
                    {/* <img src={CQ_TemplateImg} alt="" /> */}
                </div>
                <div className="slds-meida__body slds-m-left_small">
                    <h2 className="slds-text-heading_large">
                        <span className="slds-avatar slds-avatar_medium slds-m-right_small">
                            <abbr className="slds-avatar__initials slds-icon-custom-7" title="Sales Cloud">
                                <i className="cq-icon-layout cq-2x"></i> 
                            </abbr>
                        </span>Templates
                    </h2>
                </div>
            </div>
            <button className="slds-button slds-button_brand" onClick={props.fetchDeployedTemplates} >Load from Org</button>
        </div>
    );
};

export default observer(CQTemplateHeader);
